<template>
  <div class="long-text-input-container">
    <FormLabel :label="label" :isRequired="isRequired && !readOnly" />
    <div class="long-text-input-wrapper">
      <!-- readonlyモードではテキスト表示 -->
      <div v-if="readOnly" class="readonly-text">{{ displayValue }}</div>
      <!-- 通常モードではテキストエリア -->
      <textarea
        v-else
        :value="value"
        :placeholder="placeholder"
        :disabled="disabled"
        :rows="rows"
        :class="['long-text-input', { error: errorMessage }]"
        @input="onInput"
        @blur="onBlur"
      ></textarea>
    </div>
    <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
    <InputBottomDivider v-if="readOnly" />
  </div>
</template>

<script>
import FormLabel from "./FormLabel.vue";
import InputBottomDivider from "./InputBottomDivider.vue";

export default {
  name: "LongTextInput",
  components: {
    FormLabel,
    InputBottomDivider,
  },
  props: {
    /**
     * ラベルテキスト
     * @type {String}
     * @required
     */
    label: {
      type: String,
      required: true,
    },
    /**
     * 入力値
     * @type {String}
     * @default ""
     */
    value: {
      type: String,
      default: "",
    },
    /**
     * プレースホルダー
     * @type {String}
     * @default ""
     */
    placeholder: {
      type: String,
      default: "",
    },
    /**
     * テキストエリアの行数
     * @type {Number}
     * @default 4
     */
    rows: {
      type: Number,
      default: 4,
    },
    /**
     * 必須項目かどうか
     * @type {Boolean}
     * @default false
     */
    isRequired: {
      type: Boolean,
      default: false,
    },
    /**
     * 読み取り専用かどうか
     * @type {Boolean}
     * @default false
     */
    readOnly: {
      type: Boolean,
      default: false,
    },
    /**
     * 無効化されているかどうか
     * @type {Boolean}
     * @default false
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * エラーメッセージ
     * @type {String}
     * @default ""
     */
    errorMessage: {
      type: String,
      default: "",
    },
  },
  computed: {
    displayValue() {
      if (
        this.value === null ||
        this.value === undefined ||
        this.value === ""
      ) {
        return "-";
      }
      return this.value;
    },
  },
  methods: {
    onInput(e) {
      this.$emit("input", e.target.value);
    },
    onBlur(e) {
      this.$emit("blur", e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.long-text-input-container {
  display: flex;
  flex-direction: column;
  width: 100%;

  .long-text-input-wrapper {
    .readonly-text {
      padding: 0rem 0.75rem;
      font-size: 16px;
      font-weight: 400;
      font-family: $aisea-font-family;
      color: $aisea-dark-gray;
      line-height: 1.5;
      min-height: 26px;
      // 親要素の幅に合わせて折り返す
      max-width: 100%;
      word-break: break-word;
      white-space: pre-wrap;
    }

    .long-text-input {
      width: 100%;
      padding: 0.6rem 0.75rem;
      font-family: $aisea-font-family;
      font-size: 14px;
      font-weight: 400;
      color: $aisea-dark-gray;
      background-color: $aisea-pure-white;
      border: 1px solid $aisea-mouse-gray;
      border-radius: 6px;
      outline: none;
      transition: border-color 0.3s ease, box-shadow 0.3s ease;
      resize: vertical;
      white-space: pre-wrap;

      &::placeholder {
        color: $aisea-mouse-gray;
      }

      &:focus {
        border-color: #2d9cdb;
        box-shadow: 0 0 0 2px rgba(45, 156, 219, 0.1);
      }

      &:disabled {
        background-color: #f5f5f5;
        color: $aisea-mouse-gray;
        cursor: not-allowed;
      }

      &.error {
        border-color: $aisea-red;
        background-color: rgba($aisea-red, 0.1);
      }
    }
  }
  .error-message {
    margin-top: 0.25rem;
    padding-left: 0.25rem;
    font-family: $aisea-font-family;
    font-size: 12px;
    font-weight: 400;
    color: $aisea-red;
    line-height: 1.5;
  }
}
</style>
